import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ActionType } from "./actions.js";
import { addTableGroupAction, changeTableGroupColorAction, changeTableGroupNameAction, moveTableGroupAction, moveToTableGroupAction, removeTableGroupAction, resizeTableGroupAction } from "./atom.actions.js";
import { groupBy, head, last } from "es-toolkit";
//#region src/engine/modules/table-group/history.ts
var MOVE_MIN = 20;
var addTableGroup = (undoActions, { payload: { id } }) => {
	undoActions.push(removeTableGroupAction({ id }));
};
var removeTableGroup = (undoActions, { payload: { id } }, { collections }) => {
	const group = query(collections).collection("tableGroupEntities").selectById(id);
	if (!group) return;
	undoActions.push(addTableGroupAction({
		id: group.id,
		color: group.color,
		ui: { ...group.ui }
	}));
};
var changeTableGroupName = (undoActions, { payload: { id } }, { collections }) => {
	const group = query(collections).collection("tableGroupEntities").selectById(id);
	if (!group) return;
	undoActions.push(changeTableGroupNameAction({
		id,
		value: group.name
	}));
};
var moveToTableGroup = (undoActions, { payload: { id } }, { collections }) => {
	const group = query(collections).collection("tableGroupEntities").selectById(id);
	if (!group) return;
	undoActions.push(moveToTableGroupAction({
		id,
		x: group.ui.x,
		y: group.ui.y
	}));
};
var resizeTableGroup = (undoActions, { payload: { id } }, { collections }) => {
	const group = query(collections).collection("tableGroupEntities").selectById(id);
	if (!group) return;
	const { x, y, width, height } = group.ui;
	undoActions.push(resizeTableGroupAction({
		id,
		x,
		y,
		width,
		height
	}));
};
var tableGroupPushUndoHistoryMap = {
	[ActionType.addTableGroup]: addTableGroup,
	[ActionType.removeTableGroup]: removeTableGroup,
	[ActionType.changeTableGroupName]: changeTableGroupName,
	[ActionType.moveToTableGroup]: moveToTableGroup,
	[ActionType.resizeTableGroup]: resizeTableGroup
};
var moveTableGroup = (undoActions, redoActions, actions) => {
	const moveActions = actions.filter((action) => action.type === moveTableGroupAction.type);
	if (!moveActions.length) return;
	const group = groupBy(moveActions, (action) => action.payload.ids.join(","));
	for (const [, actions] of Object.entries(group)) {
		const { payload: { ids } } = head(actions);
		const { x, y } = actions.reduce((acc, { payload: { movementX, movementY } }) => {
			acc.x += movementX;
			acc.y += movementY;
			return acc;
		}, {
			x: 0,
			y: 0
		});
		if (Math.abs(x) + Math.abs(y) < MOVE_MIN) continue;
		undoActions.push(moveTableGroupAction({
			ids,
			movementX: -1 * x,
			movementY: -1 * y
		}));
		redoActions.push(moveTableGroupAction({
			ids,
			movementX: x,
			movementY: y
		}));
	}
};
var changeTableGroupColor = (undoActions, redoActions, actions) => {
	const colorActions = actions.filter(({ type }) => type === changeTableGroupColorAction.type);
	if (!colorActions.length) return;
	const group = groupBy(colorActions, (action) => action.payload.id);
	for (const [id, actions] of Object.entries(group)) {
		const firstAction = head(actions);
		const lastAction = last(actions);
		undoActions.push(changeTableGroupColorAction({
			id,
			color: firstAction.payload.prevColor,
			prevColor: lastAction.payload.color
		}));
		redoActions.push(changeTableGroupColorAction({
			id,
			color: lastAction.payload.color,
			prevColor: firstAction.payload.prevColor
		}));
	}
};
var tableGroupPushStreamHistoryMap = {
	[ActionType.moveTableGroup]: moveTableGroup,
	[ActionType.changeTableGroupColor]: changeTableGroupColor
};
//#endregion
export { tableGroupPushStreamHistoryMap, tableGroupPushUndoHistoryMap };
